// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.my-spinner[data-v-ead0f2c5] {
  display: inline-block;
}
.spinner-svg[data-v-ead0f2c5] {
  animation: spin-ead0f2c5 1s linear infinite;
}
@keyframes spin-ead0f2c5 {
0% {
    transform: rotate(0deg);
}
100% {
    transform: rotate(360deg);
}
}
.spinner-head[data-v-ead0f2c5] {
  transform-origin: center;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
